/* eslint-disable no-underscore-dangle */
import axios from 'axios';
import firebaseAuth from './firebase';

// export const baseURL = 'https://europe-west1-legitbee-ecdc5.cloudfunctions.net/api/';
export const baseURL = window._env_ ? window._env_.API_BASE_URL : (process.env.REACT_APP_API_BASE_URL || 'http://localhost:8080');
axios.defaults.baseURL = baseURL;


export default function callDb(allData, url) {
  return new Promise((resolve, reject) => {
    firebaseAuth().currentUser.getIdToken(true).then((token) => {
      axios.post(url, allData, {
        headers: {
          authorization: `Bearer ${token}`,
        },
        // httpsAgent,
      }).then((response) => {
        resolve(response);
      })
        .catch((error) => {
          console.error('API Error : ', error.status);
          console.error(JSON.stringify(error));
          reject(error);
        });
    });
  });
}

export function callDbNoAuth(allData, url) {
  return new Promise((resolve, reject) => {
    axios.post(url, allData).then((response) => {
      resolve(response);
    })
      .catch((error) => {
        console.error('API Error : ', error.status);
        console.error(JSON.stringify(error));
        reject(error);
      });
  });
}

export function getRequest(url) {
  return new Promise((resolve, reject) => {
    axios.get(url).then((response) => {
      resolve(response);
    })
      .catch((error) => {
        console.error('API Error : ', error.status);
        console.error(JSON.stringify(error));
        reject(error);
      });
  });
}
